function dropdown() {
    return {
        componentName: 'dropdown',
        baseStyle: {
            width: '200px',
            position: 'relative'
        }
    };
}

export { dropdown as default };
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZHJvcGRvd24uanMiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy90aGVtZS9jb21wb25lbnRzL2Ryb3Bkb3duLnRzIl0sInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IENvbXBvbmVudFN0eWxlIH0gZnJvbSAnLi4vdHlwZXMnO1xuXG5leHBvcnQgZGVmYXVsdCBmdW5jdGlvbiBkcm9wZG93bigpOiBDb21wb25lbnRTdHlsZSB7XG4gIHJldHVybiB7XG4gICAgY29tcG9uZW50TmFtZTogJ2Ryb3Bkb3duJyxcbiAgICBiYXNlU3R5bGU6IHtcbiAgICAgIHdpZHRoOiAnMjAwcHgnLFxuICAgICAgcG9zaXRpb246ICdyZWxhdGl2ZSdcbiAgICB9XG4gIH07XG59XG4iXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBRWMsU0FBVSxRQUFRLEdBQUE7SUFDOUIsT0FBTztBQUNMLFFBQUEsYUFBYSxFQUFFLFVBQVU7QUFDekIsUUFBQSxTQUFTLEVBQUU7QUFDVCxZQUFBLEtBQUssRUFBRSxPQUFPO0FBQ2QsWUFBQSxRQUFRLEVBQUUsVUFBVTtBQUNyQixTQUFBO0tBQ0YsQ0FBQztBQUNKOzs7OyJ9
